/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashledger_Held1Inputs */

const vi_cashledger_held1 = /** @type {(inputs: Cashledger_Held1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang giữ`)
};

/**

* @param {Cashledger_Held1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cashledger_held1 = /** @type {((inputs?: Cashledger_Held1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashledger_Held1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashledger_held1(inputs)
});
export { cashledger_held1 as "cashLedger_held" }